import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  SvgIcon,
  Link,
  Stack
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Menu as MenuIcon } from 'react-feather';
import { useIntl } from 'react-intl';

import useSettings from 'src/hooks/useSettings';
import ElevationScroll from './ElevationScroll';
import Logo from 'src/components/Logo';
import Tooltip from 'src/components/Tooltip';
import Account from './Account';
import AppLauncher from './AppLauncher';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    backgroundColor: theme.palette.background.default,
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main}0A, ${theme.palette.primary.main}03)`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `3px solid ${theme.palette.primary.main}40`
  },
  toolbar: {
    minHeight: 64
  },
  logoLink: {
    padding: '19px 8px 21px 8px'
  }
}));

const TopBar = ({ className, handleDesktopNav, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const { settings } = useSettings();
  const { formatMessage } = useIntl();

  return (
    <ElevationScroll>
      <AppBar
        position="fixed"
        className={clsx(classes.root, className)}
        {...rest}
      >
        <Toolbar className={classes.toolbar}>
          <Hidden mdUp>
            <Tooltip
              title={formatMessage({
                defaultMessage: 'メニュー',
                id: 'TopBar.Tooltip.Title'
              })}
            >
              <IconButton
                color="primary"
                onClick={onMobileNavOpen}
                size="large"
              >
                <SvgIcon fontSize="small" color="action">
                  <MenuIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Hidden>
          <Hidden mdDown>
            <Tooltip
              title={formatMessage({
                defaultMessage: 'メニュー',
                id: 'TopBar.Tooltip.Title'
              })}
            >
              <IconButton
                color="primary"
                onClick={handleDesktopNav}
                size="large"
              >
                <SvgIcon fontSize="small" color="action">
                  <MenuIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Hidden>
          <Link
            className={classes.logoLink}
            component={RouterLink}
            to="/"
            underline="none"
            color="primary"
          >
            <Logo appName={settings.appName} variant="h4" color="primary" />
          </Link>
          <Box ml={2} flexGrow={1} />
          <Stack ml={2} spacing={2} direction={'row'}>
            <AppLauncher />
            <Account />
          </Stack>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  handleDesktopNav: PropTypes.func,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default TopBar;
